import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { UserService } from '../../service/user.service';


/**
 * example:
 * https://satphonerecharge.com/code-confirmation/01K9JY1X06SKT6YB7EJ7TPCR8S/276921
 */
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: '../code-confirmation/code-confirmation.component.html',
  styleUrl: '../code-confirmation/code-confirmation.component.scss'
})
export class CodeConfirmationComponent implements OnInit {
  refCode: string | null = null;
  code: string | null = null;
  error: string | null = null;
  email: string | null = null;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly usersService: UserService
  ) {
  }

  ngOnInit() {
    this.route.paramMap.subscribe(async params => {
      await this.confirmUser(params);
    });
  }

  async goToDashboard() {
    await this.router.navigate(["/"], {replaceUrl: true})
  }

  async confirmUser(params: ParamMap) {
    this.code = params.get('code');
    this.refCode = params.get('refCode');
    if (!this.code || !this.refCode) {
      await this.goToDashboard();
      return;
    }

    const result = await this.usersService.confirmSignUp(this.refCode, this.code);
    if (result.error) {
      this.error = result.error;
    } else if (result.email) {
      this.email = result.email;
    } else {
      console.error('Unhandled error');
      await this.goToDashboard();
    }
  }

}
